/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { NumberTypes } from '@gh/common-shared';
import { FormMode, getControlValue, setControlValue } from '@gh/core-ui';

import { FranchiseReportFilter } from '../../resources/franchise-monthly-report.model';

@Injectable()
export class FranchiseReportFilterFormState extends FormState<FranchiseReportFilter> {

  constructor(private schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  getMonthCodeValue(): string {
    return getControlValue(this.group, 'monthCode');
  }

  setMonthCodeValue(monthCode: string): void {
    setControlValue(this.group, 'monthCode', monthCode);
  }

  getForYearValue(): number {
    return getControlValue(this.group, 'forYear');
  }

  getForMonthValue(): number {
    return getControlValue(this.group, 'forMonth');
  }

  getAllApprovalsValue(): number {
    return getControlValue(this.group, 'allApprovals');
  }

  getTrafficValue(): number {
    return getControlValue(this.group, 'trafficValue');
  }

  getNoOfStuffValue(): number {
    return getControlValue(this.group, 'noOfStuff');
  }

  getStaffHoursPaidValue(): number {
    return getControlValue(this.group, 'staffHoursPaid');
  }

  getFinalizedJobsValue(): number {
    return getControlValue(this.group, 'finalizedJobs');
  }

  getConstVarianceValue(): number {
    return getControlValue(this.group, 'constVariance');
  }

  getMemoValue(): string {
    return getControlValue(this.group, 'memo');
  }

  getWhs(): boolean {
    return getControlValue(this.group, 'whs');
  }

  getWhsDetails(): string {
    return getControlValue(this.group, 'whsDetails');
  }
  protected buildSchema(_: FranchiseReportFilter, { root }: FormStateSchema): FormRootSchema {
    return root({
      enabled: true,
      mode: FormMode.EditMode,
      children: {
        id: void 0,
        monthCode: void 0,
        forMonth: void 0,
        forYear: void 0,
        allApprovals: { type: NumberTypes.QuantityIntegral },
        trafficValue: { required: true, type: NumberTypes.QuantityIntegral },
        noOfStuff: { required: true, type: NumberTypes.QuantityIntegral },
        staffHoursPaid: { required: true, type: NumberTypes.QuantityIntegral },
        finalizedJobs: { enabled: false, type: NumberTypes.QuantityIntegral },
        constVariance: { enabled: false, type: NumberTypes.QuantityIntegral },
        whs: void 0,
        whsDetails: void 0,
        memo: void 0,
        version: void 0,
      },
    });
  }
}
